import AuthService from './Auth.service';

export default function authHeader() {
    const user = AuthService.GetCookie();

    if (user) {
        return { Authorization: 'Bearer ' + user };
    } else {
        if (process.env.NODE_ENV === "production")
            if (process.env.REACT_APP_PRENV === "false")
                window.location.replace('https://auth.agrifoodatsolutions.com?service=AGRF_FP_WEBAPP&solution=AGRF_FP');
            else
                window.location.replace('https://auth.agrifoodatsolutions.com?service=AGRF_FP_WEBAPP&solution=AGRF_FP&env=pre');
        else
            window.location.href = '/login';
    }
}